let route = {
    path: '/modules/subject/sys',
    name: 'subject-sys',
    component: () => import('@/modules/subject/index.vue'),
    children: [
        //价格管理
        {
            path: 'subject-manage/index',
            name: 'Subject-Sys-Subject-Manage',
            component: () => import('@/modules/subject/subject-manage/index.vue'),
            meta: {
                pageTitle: '价格管理',
            }
        },
        //门店资金管理
        {
            path: 'price-manage/index',
            name: 'Subject-Sys-Price-Manage',
            component: () => import('@/modules/subject/price-manage/index.vue'),
            meta: {
                pageTitle: '门店资金管理',
            }
        },
    ],
    meta: {
        role: 'xurui_admin'
    }
};
export const SubjectRouter = route;
